import { render } from "./TablePlus.vue?vue&type=template&id=bf72a288"
import script from "./TablePlus.vue?vue&type=script&lang=js"
export * from "./TablePlus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TablePlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf72a288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf72a288', __exports__)) {
    api.reload('bf72a288', __exports__)
  }
  
  module.hot.accept("./TablePlus.vue?vue&type=template&id=bf72a288", () => {
    api.rerender('bf72a288', render)
  })

}


export default __exports__